import { render } from "./PartnerLogin.vue?vue&type=template&id=3b27744b&scoped=true"
import script from "./PartnerLogin.vue?vue&type=script&lang=js"
export * from "./PartnerLogin.vue?vue&type=script&lang=js"

import "./PartnerLogin.vue?vue&type=style&index=0&id=3b27744b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b27744b"]])

export default __exports__